import { ref } from "vue"

const resetState = () => {
    states.value.user = null;
    states.value.confirmationResult = null;
    states.value.signup = false;
    states.value.is_reload = false;
    states.value.authIsReady = true;  // Keep true after first auth check
    states.value.colorIcon = '';
    states.value.flag = false;
    states.value.substatus = false;
    states.value.notificationToken = '';
    states.value.showVolunteer = false;
    states.value.newReqs = [];
    states.value.matchedVols = 0;
    states.value.matchedReqs = 0;
    states.value.matchedReqsOff = false;
    states.value.matchedVolsOff = false;
    states.value.controlledUser = null;
    states.value.volunteersArray = [];
    states.value.creatorsArray = [];
    states.value.groupReqList = [];
    states.value.groupVolList = [];
    states.value.volunteeringRequestData = [];
    states.value.bckImage = null;
    states.value.activeFamMember = null;
    states.value.createAct = false;
    states.value.authPhoneNumber = null;
    states.value.authEmail = null;
};

const states = ref({
    user: null,
    confirmationResult: null,
    signup: false,
    is_reload: true,  // Start true to show loading until auth check completes
    authIsReady: false,  // Track when Firebase auth check is complete
    deferredInstallPrompt: null,  // Store PWA install prompt event globally
    colorIcon: '',
    flag: false,
    substatus: false,
    notificationToken: '',
    showVolunteer: false,
    newReqs: [],
    matchedVols: 0,
    matchedReqs: 0,
    matchedReqsOff: false,
    matchedVolsOff: false,
    controlledUser: null,
    volunteersArray: [],
    creatorsArray: [],
    groupReqList: [],
    groupVolList: [],
    volunteeringRequestData: [],
    bckImage: null,
    activeFamMember: null,
    createAct: false,
    authPhoneNumber: null,
    authEmail: null
})

export {
    states, resetState
}